import template from "./analytics.html";
import controller from "./analytics.controller";
import "./analytics.scss";

const AnalyticsComponent = {
    template,
    controller,
    controllerAs: "Analytics"
};

export default AnalyticsComponent;


// WEBPACK FOOTER //
// ./sources/components/analytics/analytics.component.js